import { httpDelete, httpGet } from "./index";

const enc = (value: string) => encodeURIComponent(String(value));

export const getOAuthDynamicClients = async (serverId: string) => {
  return httpGet(`/mcp-servers/${enc(serverId)}/clients`, {});
};

export const getOAuthDynamicClient = async (serverId: string, clientId: string) => {
  return httpGet(`/mcp-servers/${enc(serverId)}/clients/${enc(clientId)}`, {});
};

export const deleteOAuthDynamicClient = async (serverId: string, clientId: string) => {
  return httpDelete(`/mcp-servers/${enc(serverId)}/clients/${enc(clientId)}`, {});
};

export const getOAuthDynamicClientUsers = async (serverId: string, clientId: string) => {
  return httpGet(`/mcp-servers/${enc(serverId)}/clients/${enc(clientId)}/users`, {});
};

export const revokeOAuthDynamicClientUser = async (serverId: string, clientId: string, uid: string) => {
  return httpDelete(`/mcp-servers/${enc(serverId)}/clients/${enc(clientId)}/users/${enc(uid)}`, {});
};
